module.exports = __webpack_public_path__ + "static/media/ellipsis.a95fbaa5.gif";